// Funeral Validation
function handleFuneralValidation(event) {
  const textArea1 = document.getElementById('custom-text2');
  const textArea2 = document.getElementById('custom-text3');
  if (textArea1 && textArea2) {
      if (textArea1.value === '' || textArea2.value === '') {
          event.preventDefault();
      }
      if (textArea1.value === '') {
          textArea1.reportValidity();
      } else if (textArea2.value === '') {
          textArea2.reportValidity();
      }
  }
}
// Giftset Validation
function handleGiftsetValidation(event) {
  const textArea1 = document.getElementById('giftset-text1');
  const textArea2 = document.getElementById('giftset-text2');
  const textArea3 = document.getElementById('giftset-text3');
  if (textArea1 && textArea2 && textArea3) {
      if (textArea1.value === '' || textArea2.value === '' || textArea3.value === '') {
          event.preventDefault();
      }
      if (textArea1.value === '') {
          textArea1.reportValidity();
      } else if (textArea2.value === '') {
          textArea2.reportValidity();
      } else if (textArea3.value === '') {
          textArea3.reportValidity();
      }
  }
}
// Combined Event Listener
document.querySelector('.product-form__submit').addEventListener('click', (event) => {
  const isGiftsetPage = document.getElementById('giftset-text1') !== null;
  const isFuneralPage = document.getElementById('custom-text2') !== null;

  if (isGiftsetPage) {
      console.log('Giftset validation triggered');
      handleGiftsetValidation(event);
  } else if (isFuneralPage) {
      console.log('Funeral validation triggered');
      handleFuneralValidation(event);
  } else {
      console.log('No validation triggered');
  }
});